import { TypographyColor } from 'melp-design/components';
import { VoucherStatus } from './admin-shop-vouchers.types';

export const COLOR_BY_STATUS: Record<VoucherStatus, TypographyColor> = {
  available: 'success',
  expired: 'error',
  archived: 'textSecondary',
  sold: 'primary',
};
